import React, { useEffect, useState } from 'react';
import PropTypes from "prop-types";
import StyledRadioInput from "../../../Helpers/Inputs/StyledRadioInput";
import { mixed, object, string } from "yup";
import { customValidators } from "../../../Helpers/Validators/customValidators";
import { useForm } from 'react-hook-form/dist/react-hook-form.ie11';
import { Form, Col, Row, Container } from 'react-bootstrap';
import { SelectInput, TextInput } from '../../../Helpers/Inputs';
import moment from 'moment';
import { InputMaskOfficeFA } from "../../../Helpers/Formatters/InputMaskClientAccount";
import { httpRequest } from "../../../../httpRequest";
import { CircularProgress } from '@material-ui/core';
import TitleComponent from '../../../Common/TitleComponent';
import SingleUserSearch from '../../../../icons/SingleUserSearch.svg';
import BackNextButton from '../../../Common/BackNextButton';
import { ADVISOR_OBJECT_KEY, getSessionStorageItem, ILLUSTRATION_PREFILL_DATA, SESSION_STORAGE_ACCOUNT_KEY, SESSION_STORAGE_CLIENT_ACCOUNT_INFO, setSessionStorageItem } from '../../../../sessionStorage';
import { EsignerRole, AccountTypes, yesNoOptions, OwnerType } from '../../../Common/Constant';
import useUserInfo from "../../../../hooks/useUserInfo";
import { retrieveAccountUserSetup } from "./Helpers";
import { insurancePolicyTypes } from '../../ABLTC/SubComponents/SelectOptions';
import { clientTypeOptions, getMatchingOwnerList, getAdvisorList, getJointOwnerList, getOwnerList, getQuoteList, policyOwnerships, validAccountDetails } from './Helpers/Constants';
import ExistingClientAccountFields from './SubComponents/ExistingClientAccountFields';
import ReactHtmlParser from 'react-html-parser';
import PolicyAndInsuredFields from './SubComponents/PolicyAndInsuredFields';
import AccountTypesAndOwnerFields from './SubComponents/AccountTypesAndOwnerFields';
import { PrefillABLTCInsuredInfo } from './SubComponents/PrefillABLTCInsuredInfo';

export default function RetrieveAccount(props) {

  const { faOptions, role } = useUserInfo();

  const [ownerList, setOwnerList] = useState([]);
  const [quoteList, setQuoteList] = useState([]);
  const [faList, setFaList] = useState([]);
  const [officeList, setOfficeList] = useState([]);
  const [showDropDown, setShowDropDown] = useState(false);
  const [advisorList, setAdvisorList] = useState([]);
  const [clientData, setClientData] = useState(props.formState.clientData);
  const [selectedOwnerRec, setSelectedOwnerRec] = useState(props.formState.selectedOwner);
  const [errorMessage, setErrorMessage] = useState('');
  const [loading, setLoading] = useState(false);
  const [jointOwner, setJointOwner] = useState([]);
  const [visible, setVisible] = useState(false);
  const isSubmitCase = props.isSubmitCase || false;

  const accountObj = getSessionStorageItem(SESSION_STORAGE_ACCOUNT_KEY);
  const clientAccountType = clientData && clientData.accountType && clientData.accountType.toLowerCase();
  const retrieveSavedQuotes = clientData && clientData.savedQuotes && clientData.savedQuotes.length > 0;
  const sessionData = getSessionStorageItem(ILLUSTRATION_PREFILL_DATA);
  const isMSEnableSurvivorshipWorkflow = props.isABLTC || isSubmitCase;

  const { register, errors, handleSubmit, setValue, triggerValidation, reset } = useForm({
    validationSchema: RetrieveAccount.ValidationSchema(clientData, jointOwner, selectedOwnerRec, props.hideClientTypeRadio, props.isTerm, props.isTermRetrieveQuote, showDropDown, officeList.length, isMSEnableSurvivorshipWorkflow),
    mode: 'onBlur',
    reValidateMode: 'onBlur',
  });

  const setDifferentOwners = (clientInfo) => {
    let combinedOwnerList = [...clientInfo.owners];
    let fullForm = props.fullFormState;
    clientInfo.soleProprieter && clientInfo.soleProprieter.forEach((element) => {
      combinedOwnerList.push(element);
    })

    if (combinedOwnerList.length === 1) {
      fullForm.pages.retrieveAccount.owner = combinedOwnerList[0].covrGeneratedID;
      fullForm.pages.retrieveAccount.ownerDetails = combinedOwnerList[0]
      fullForm.pages.retrieveAccount.selectedOwner = combinedOwnerList[0];
    }
    setOwnerList(combinedOwnerList);
    setQuoteList(clientInfo.savedQuotes);
    setAdvisorList(clientInfo.licenseCheckResponse.quoteFAList);
    let jointOwnerList = [];
    clientInfo.owners && clientInfo.owners.map((index) => {
      if (index.isPrimary === 'N')
        jointOwnerList.push(index);
    })
    setJointOwner(jointOwnerList);
    props.onMultiFieldChange(fullForm);
  }

  useEffect(() => {
    window.scroll(0, 0);
    if (props.isCopyCaseData && (Object.keys(props.formState.clientData).length === 0)) {
      msFetchClientAccount(true);
    }

    if (Object.keys(props.formState.clientData).length !== 0) {
      setVisible(true);
      if (props.formState.clientType === "Prospect" && !props.isTerm && !props.hideClientTypeRadio) {
        setAdvisorList(props.formState.clientData.licenseCheckResponse.quoteFAList);
        return
      }
      setDifferentOwners(clientData);
    }

    retrieveAccountUserSetup(faOptions, role, setShowDropDown, setFaList, setOfficeList);
  }, []);

  const handleValueChange = (field, value) => {
    let fullForm = { ...props.fullFormState };
    if (field === 'clientType' && value === 'Prospect' && props.setAllFormOnAccountNoChanged) {
      props.setAllFormOnAccountNoChanged();
    }
    if ((field === 'faNum' && props.formState.officeNum !== '') || (field === 'officeNum' && props.formState.faNum !== '')) {
      fullForm.pages.retrieveAccount[field] = value;
      fullForm.pages.retrieveAccount.officeFa = fullForm.pages.retrieveAccount.officeNum + '-' + fullForm.pages.retrieveAccount.faNum;
      props.onMultiFieldChange(fullForm);
    }
    if (field === 'branchOptions') {
      fullForm.pages.retrieveAccount.branchOptions = value;
      if (sessionData && sessionData.selectedCaseDetails) {
        fullForm.pages.retrieveAccount.officeAccount = sessionData.selectedCaseDetails.clientBranchNumber + '-' + sessionData.selectedCaseDetails.clientAccountNumber;
      }
      else {
        fullForm.pages.retrieveAccount.officeAccount = '';
      }
      fullForm.pages.retrieveAccount.officeFa = '';
      setErrorMessage('');
      if (value === 'SELECT') {
        if (sessionData && sessionData.selectedCaseDetails) {
          let faDetails = (faList.find(x => x.label === sessionData.selectedCaseDetails.faOfficeNumber + '-' + sessionData.selectedCaseDetails.faNumber));
          let faName = (faList.length > 0 && faDetails && faDetails.value) || '';
          fullForm.pages.retrieveAccount.officeFa = faName;
        }
        fullForm.pages.retrieveAccount.faNum = '';
        fullForm.pages.retrieveAccount.officeNum = '';
      }
      else if (value === 'INPUT') {
        if (sessionData && sessionData.selectedCaseDetails) {
          fullForm.pages.retrieveAccount.faNum = sessionData.selectedCaseDetails.faidInput;
          fullForm.pages.retrieveAccount.officeNum = sessionData.selectedCaseDetails.faOfficeNumberInput;
          fullForm.pages.retrieveAccount.officeFa = sessionData.selectedCaseDetails.faOfficeNumberInput + '-' + sessionData.selectedCaseDetails.faidInput;
        }
        else
          fullForm.pages.retrieveAccount.officeFa = '';
      }
      props.onMultiFieldChange(fullForm);
      setLoading(false)
    }
    if (field === "isProposedInsured" && value === "false" && isSubmitCase) {
      fullForm.pages.retrieveAccount.isProposedInsured = value;
      fullForm.pages.insuredBasicInfo.state = props.isCopyCaseData ? fullForm.pages.insuredBasicInfo.state : "";
      fullForm.pages.insuredBasicInfo.birthdate = props.isCopyCaseData ? fullForm.pages.insuredBasicInfo.birthdate : "";
      props.onMultiFieldChange(fullForm);
    }
    if (field === 'insured' || field === 'secondInsured') {
      fullForm.pages.insuredBasicInfo = props.insuredInfoDefaultState;
      props.onMultiFieldChange(fullForm);
    }
    if (field === 'insured' && props.formState.isProposedInsured === 'true') {
      fullForm.pages.retrieveAccount.ownerDetails = fullForm.pages.retrieveAccount.clientData.owners.find(el => el.covrGeneratedID === value);
      fullForm.pages.retrieveAccount.insured = value;
      props.onMultiFieldChange(fullForm);
    } else if (field === 'isProposedInsured') {
      fullForm.pages.insuredBasicInfo = props.insuredInfoDefaultState;
      fullForm.pages.retrieveAccount.insured = '';
      if (value === 'true') {
        fullForm.pages.retrieveAccount.ownerDetails = fullForm.pages.retrieveAccount.clientData.owners.find(el => el.covrGeneratedID === fullForm.pages.retrieveAccount.owner) || fullForm.pages.retrieveAccount.clientData.soleProprieter.find(el => el.covrGeneratedID === fullForm.pages.retrieveAccount.owner);
      } else {
        fullForm.pages.retrieveAccount.ownerDetails = {};
      }
      fullForm.pages.retrieveAccount.isProposedInsured = value;
      props.onMultiFieldChange(fullForm);
    } else if (field === "advisor") {
      fullForm.pages.retrieveAccount.advisor = value;

      //remove any previous assignments
      fullForm.pages.retrieveAccount.clientData.licenseCheckResponse.quoteFAList.forEach((element) => {
        element.primary = false;
      })

      fullForm.pages.retrieveAccount.clientData.licenseCheckResponse.quoteFAList.map((advisor, index) => {
        if (advisor.agentID === Number.parseInt(value)) {
          fullForm.pages.retrieveAccount.clientData.licenseCheckResponse.quoteFAList[index].primary = true;
        } else {
          fullForm.pages.retrieveAccount.clientData.licenseCheckResponse.quoteFAList[index].primary = false;
        }
      })
      props.onMultiFieldChange(fullForm);
    } else if (field === "owner" && value) {
      let selectedOwnerRecord = ownerList.find(o => o.covrGeneratedID === value);
      fullForm.pages.retrieveAccount.owner = selectedOwnerRecord.covrGeneratedID;
      props.formState.selectedOwner = selectedOwnerRecord;
      setSelectedOwnerRec(props.formState.selectedOwner);

      if (clientData.accountType && (clientAccountType === AccountTypes.PARTNERSHIP || clientAccountType === AccountTypes.UNINCORPORATED && (clientData.accountSubclass && clientData.accountSubclass.toLowerCase() === AccountTypes.SOLE_PROPRIETOR)) && (selectedOwnerRecord.ownerType && selectedOwnerRecord.ownerType.toLowerCase() === OwnerType.ORGANIZATION)) {
        props.formState.isProposedInsured = 'false';
        fullForm.pages.retrieveAccount.ownerDetails = {};
        fullForm.pages.insuredBasicInfo = props.insuredInfoDefaultState;
        setValue('isProposedInsured', props.formState.isProposedInsured);
      } else {
        fullForm.pages.retrieveAccount.ownerDetails = fullForm.pages.retrieveAccount.clientData.owners.find(el => el.covrGeneratedID === value) || fullForm.pages.retrieveAccount.clientData.soleProprieter.find(el => el.covrGeneratedID === value);
      }
      props.onMultiFieldChange(fullForm);
    } else if (field === "policyOwnership") {
      fullForm.pages.retrieveAccount.ownerDetails = {};
      fullForm.pages.retrieveAccount.jointOwner = '';
      fullForm.pages.retrieveAccount.insured = '';
      fullForm.pages.retrieveAccount.owner = '';
      fullForm.pages.retrieveAccount.policyOwnership = value;
      if (value === policyOwnerships.JOINT && jointOwner && jointOwner.length === 1) {
        const jointOwnerValue = getJointOwnerList(jointOwner)[0].value;
        setValue('jointOwner', jointOwnerValue);
        fullForm.pages.retrieveAccount.jointOwner = jointOwnerValue;
      }
      props.onMultiFieldChange(fullForm);
    } else if (field === "insurancePolicyType") {
      fullForm.pages.retrieveAccount = {
        ...fullForm.pages.retrieveAccount,
        insured: '',
        secondInsured: '',
        isProposedInsured: '',
        insurancePolicyType: value,
      }
      setValue('insured', '');
      setValue('secondInsured', '');
      setValue('isProposedInsured', '');
      props.onMultiFieldChange(fullForm);
    } else if (field === 'clientType') {
      props.setAllFormOnAccountNoChanged(value);
    } else {
      if (field === 'officeFa' || field === 'officeAccount') {
        setVisible(false);
      }
      props.onFieldChange(field, value);
    }
    setValue(field, value);
    triggerValidation(field);
  };

  const handleOnSubmit = async () => {
    if (errorMessage === '' && validAccountDetails(props) && !visible) {
      msFetchClientAccount();
      return;
    }
    const covrServicesUrl = process.env.REACT_APP_COVR_SERVICES_URL;
    const isProposedInsured = props.fullFormState.pages.retrieveAccount.isProposedInsured;
    const fullForm = { ...props.fullFormState };
    if (props.isTermRetrieveQuote && props.formState.isSavedQuote === 'true') {
      await httpRequest.get(`${covrServicesUrl}/api/MorganStanley/GetMorganStanleySavedQuoteByID?morganStanleySavedQuoteID=${parseInt(props.formState.selectQuote, 10)}`)
        .then((data) => {
          if (data && data.success === true) {
            const quoteData = data.content;
            const stringOfDob = quoteData.birthDate ? moment(quoteData.birthDate).format('MM/DD/YYYY') : '';
            if (isProposedInsured === "true") {
              fullForm.pages.insuredBasicInfo.birthdate = stringOfDob;
              fullForm.pages.insuredBasicInfo.gender = quoteData.gender;
              fullForm.pages.insuredBasicInfo.tobacco = quoteData.tobacco ? 'true' : 'false';
              fullForm.pages.insuredBasicInfo.maritalStatus = quoteData.maritalStatus;
            }
            fullForm.pages.insuredBasicInfo.state = quoteData.state;
            fullForm.pages.quoter.term = quoteData.coverageLength;
            fullForm.pages.quoter.healthClass = quoteData.healthClass;
            fullForm.pages.quoter.tableRating = quoteData.substandard;
            fullForm.pages.quoter.coverageAmount = quoteData.faceAmount;
            if (quoteData.childRider > 0) {
              fullForm.pages.quoter.childRider = true;
              fullForm.pages.quoter.benefitAmount = quoteData.childRider;
            }
            fullForm.pages.quoter.accidentalDeathBenefit = quoteData.accidentalDBRider;
            fullForm.pages.quoter.acceleratedDeathBenefit = quoteData.acceleratedDBRider;
            fullForm.pages.quoter.waverOfPremium = quoteData.waiverOfPremium;
          }
        })
    }
    if (props.esignData) {
      let PIRole = props.formState.isProposedInsured && fullForm.pages.esign && fullForm.pages.esign.esigner.find(x => x.role === EsignerRole.PROPOSED_INSURED)
      let ownerRolesArr = [EsignerRole.JOINT_OWNER, EsignerRole.OWNER, EsignerRole.PRIMARY_OWNER];
      let ownerRole = props.formState.policyOwnership && fullForm.pages.esign.esigner.find(x => ownerRolesArr.includes(x.role));
      if (fullForm.pages.esign && fullForm.pages.esign.esigner.length > 1 && (PIRole || ownerRole)) {
        fullForm.pages.esign = props.esignData;
      }
    }

    if (props.isABLTC && [AccountTypes.INDIVIDUAL, AccountTypes.JOINT, AccountTypes.TRUST, AccountTypes.PARTNERSHIP, AccountTypes.UNINCORPORATED, AccountTypes.LIMITED_LIABILITY, AccountTypes.RPM].includes(clientAccountType.toLowerCase())) {
      PrefillABLTCInsuredInfo(fullForm, clientData, { ...props.formState }, ownerList, props.insuredInfoDefaultState)
    }
    if (props.isCopyCaseData && props.formState.copiedOwnerInsuredData) {
      const { copiedOwnerInsuredData, ...retrieveAccountFields } = fullForm.pages.retrieveAccount;
      fullForm.pages.retrieveAccount = retrieveAccountFields;
    }
    props.onMultiFieldChange(fullForm);
    props.onNext();
  }

  useEffect(() => {
    const arrayOfFields = ['clientType', 'clientData', 'isProposedInsured', 'officeFa', 'officeAccount', 'advisor',
      'owner', 'selectedOwner', 'policyOwnership', 'jointOwner', 'insured', 'ownerDetails', 'isSavedQuote', 'selectQuote',
      'branchOptions', 'faNum', 'officeNum', 'insurancePolicyType', 'secondInsured'];

    arrayOfFields.map((field) => {
      register({ name: field });
      setValue(field, props.formState[field]);
    })
  }, [register]);

  useEffect(() => {
    const { formState, fullFormState, isCopyCaseData, onMultiFieldChange } = props;
    const { owner, jointOwner: jointOwnerValue, insured, secondInsured, copiedOwnerInsuredData, advisor } = formState;
    let fullForm = { ...fullFormState };
    let retrieveAccount = fullForm.pages.retrieveAccount;
    let insuredBasicInfoPage = fullForm.pages.insuredBasicInfo;

    if (!isCopyCaseData || !copiedOwnerInsuredData || Object.keys(props.formState.clientData).length === 0 || !retrieveAccount) return;

    if (advisor && advisorList && advisorList.length > 0 && retrieveAccount.clientData && retrieveAccount.clientData.licenseCheckResponse && retrieveAccount.clientData.licenseCheckResponse.quoteFAList) {
      retrieveAccount.clientData.licenseCheckResponse.quoteFAList.forEach((element) => {
        element.primary = (element.agentID === Number.parseInt(advisor));
      })
    }
    
    // --- Owner ---
    if (!owner && ownerList && ownerList.length > 0) {
      const matches = getMatchingOwnerList(ownerList, copiedOwnerInsuredData.ownerFirstName, copiedOwnerInsuredData.ownerLastName, copiedOwnerInsuredData.ownerBirthDate);
      if (matches.length === 1) {
        const matchedOwner = matches[0];
        let selectedOwnerRecord = ownerList.find(o => o.covrGeneratedID === matchedOwner.covrGeneratedID);
        retrieveAccount.owner = matchedOwner.covrGeneratedID;
        retrieveAccount.selectedOwner = selectedOwnerRecord;
        setSelectedOwnerRec(selectedOwnerRecord);

        if (clientData.accountType && (clientAccountType === AccountTypes.PARTNERSHIP || clientAccountType === AccountTypes.UNINCORPORATED && (clientData.accountSubclass && clientData.accountSubclass.toLowerCase() === AccountTypes.SOLE_PROPRIETOR)) && (selectedOwnerRecord.ownerType && selectedOwnerRecord.ownerType.toLowerCase() === OwnerType.ORGANIZATION)) {
          props.formState.isProposedInsured = 'false';
          retrieveAccount.ownerDetails = {};
          fullForm.pages.insuredBasicInfo = props.isCopyCaseData && props.formState.copiedOwnerInsuredData ? props.fullFormState.pages.insuredBasicInfo : props.insuredInfoDefaultState;
          setValue('isProposedInsured', 'false');
        } else {
          retrieveAccount.ownerDetails = retrieveAccount.clientData.owners.find(el => el.covrGeneratedID === matches[0].covrGeneratedID) || retrieveAccount.clientData.soleProprieter.find(el => el.covrGeneratedID === matches[0].covrGeneratedID);
        }
        setValue("owner", matchedOwner.covrGeneratedID);
      } else {
        retrieveAccount.owner = "";
        setValue("owner", "");
      }
    }

    // --- Joint Owner ---
    if (!jointOwnerValue && jointOwner && jointOwner.length > 0) {
      const matches = getMatchingOwnerList(jointOwner, copiedOwnerInsuredData.jointOwnerFirstName, copiedOwnerInsuredData.jointOwnerLastName, copiedOwnerInsuredData.jointOwnerBirthDate);
      if (matches.length === 1) {
        retrieveAccount.jointOwner = matches[0].covrGeneratedID;
        setValue("jointOwner", matches[0].covrGeneratedID);
      } else {
        retrieveAccount.jointOwner = "";
        setValue("jointOwner", "");
      }
    }

    // --- Insured ---
    if (!insured && ownerList && ownerList.length > 0 && copiedOwnerInsuredData.piIsOwner) {
      const matches = getMatchingOwnerList(ownerList, copiedOwnerInsuredData.piFirstName, copiedOwnerInsuredData.piLastName, copiedOwnerInsuredData.piBirthdate);
      if (matches.length === 1) {
        retrieveAccount.insured = matches[0].covrGeneratedID;
        setValue("insured", matches[0].covrGeneratedID);
      } else if (insuredBasicInfoPage.proposedInsuredFirstName || insuredBasicInfoPage.proposedInsuredLastName) {
        retrieveAccount.insured = "Other";
        setValue("insured", "Other");
        insuredBasicInfoPage.isOther = true;
      } else {
        retrieveAccount.insured = "";
        setValue("insured", "");
      }
    }

    // --- Secondary Insured ---
    if (!secondInsured && formState.insurancePolicyType === insurancePolicyTypes.SURVIVORSHIP && copiedOwnerInsuredData.secondaryInsuredSameAsOwner
    ) {
      const matches = getMatchingOwnerList(ownerList, copiedOwnerInsuredData.pi2FirstName, copiedOwnerInsuredData.pi2LastName, copiedOwnerInsuredData.pi2Birthdate);
      if (matches.length === 1) {
        retrieveAccount.secondInsured = matches[0].covrGeneratedID;
        setValue("secondInsured", matches[0].covrGeneratedID);
      } else if (insuredBasicInfoPage.secondaryInsuredFirstName || insuredBasicInfoPage.secondaryInsuredLastName) {
        retrieveAccount.secondInsured = "Other";
        setValue("secondInsured", "Other");
        insuredBasicInfoPage.isSecondaryInsuredOther = true;
      } else {
        retrieveAccount.secondInsured = "";
        setValue("secondInsured", "");
      }
    }
    onMultiFieldChange(fullForm);
  }, [advisorList, props.formState.clientData, ownerList, jointOwner]);

  const msFetchClientAccount = (isSetPrefillData = false) => {
    setLoading(true);
    setErrorMessage('');
    if (validAccountDetails(props)) {
      let branchNum = props.formState.officeAccount.trim().split('-')[0];
      const officeFa = props.formState.officeFa.trim().split('-')[0];
      const faNum = props.formState.officeFa.trim().split('-')[1];
      let accountNum;
      if (props.formState.clientType === "Prospect" && !props.isTerm && !props.hideClientTypeRadio) {
        branchNum = props.formState.officeFa.trim().split('-')[0];
        accountNum = "";
      } else {
        accountNum = props.formState.officeAccount.trim().split('-')[1];

      }
      const covrServicesUrl = process.env.REACT_APP_COVR_SERVICES_URL;
      const advisorObj = getSessionStorageItem(ADVISOR_OBJECT_KEY);
      const externalUserId = advisorObj && advisorObj.externalUserId;
      const oneClickAccountId = accountObj && accountObj.account.oneClickAccountId;

      httpRequest.get(`${covrServicesUrl}/api/MorganStanley/GetClientAccountInfo?branchNum=${branchNum}&accountNum=${accountNum}&faNum=${faNum}&oneClickAccountId=${oneClickAccountId}&externalUserID=${externalUserId}&faOffice=${officeFa}&clientType=${props.formState.clientType}`).then((data) => {
        setLoading(true);
        if (!data || data.success === false) {
          if (data.content === null && data.messages !== null && data.messages.length > 0) {
            setErrorMessage(data.messages.map(a => a.message).join(' '));
            return;
          }
          setErrorMessage('Message from Covr: No customer details found for account/branch number combination. Please try again.');
        } else {
          setSessionStorageItem(SESSION_STORAGE_CLIENT_ACCOUNT_INFO, data.content);
          setLoading(false);
          if (props.formState.clientType === "Prospect" && !props.isTerm && !props.hideClientTypeRadio) {
            if (data.content && data.content.licenseCheckResponse && data.content.licenseCheckResponse.success) {
              setAdvisorList(data.content && data.content.licenseCheckResponse && data.content.licenseCheckResponse.quoteFAList);
              setClientData(data.content);
              handleValueChange('clientData', data.content);
            } else {
              setErrorMessage("Failed to get client account information. ");
            }
            setVisible(true);
            return
          }
          if (data.content.status.toLowerCase() === "success") {
            props.setAllFormOnAccountNoChanged(null, isSetPrefillData);
            setVisible(true);

            setDifferentOwners(data.content);
            setClientData(data.content);
            handleValueChange('clientData', data.content);
            if (!props.copiedOwnerInsuredData) reset();
          } else if (data.content.status.toLowerCase() === "failure") {
            let message = "";
            if (data.content.errors.length > 0) {
              data.content.errors.map((index) => {
                let code = index.errorCode;
                let errorMessage = index.errorMessage;
                message += `${code}: ${errorMessage}`
              })
            }
            setErrorMessage(message);
          } else if (data.content.residentState === "") {
            setErrorMessage("Client account does not have resident state.")
          }

        }
      })
    } else {
      setLoading(false);
      return;
    }
  }

  const getPrimaryOwner = () => {
    let primaryOwner = { label: '', value: '' }
    if (ownerList !== undefined && ownerList.length !== 0) {
      ownerList.forEach((element) => {
        if (element.isPrimary === 'Y') {
          let middleInitial = element.middleName.charAt(0);
          primaryOwner.label = element.firstName + ' ' + middleInitial + ' ' + element.lastName;
          primaryOwner.value = element.covrGeneratedID;
          if (props.formState.owner === "" && !(props.isCopyCaseData && props.formState.copiedOwnerInsuredData)) {
            let fullForm = props.fullFormState;
            fullForm.pages.retrieveAccount.owner = element.covrGeneratedID;
            props.onMultiFieldChange(fullForm);
          }
        }
      })
    }
    return primaryOwner;
  }

  const getInsuredList = () => {
    const primaryOwner = getPrimaryOwner();
    const jointOwnerList = getJointOwnerList(jointOwner);
    let selectedOwner = jointOwnerList.find((e) => e.value === props.formState.jointOwner)
    return [{ label: primaryOwner.label, value: primaryOwner.value },
    { label: selectedOwner.label, value: selectedOwner.value }]
  }

  const getFirstInsuredOptions = (isAddOther = false) => {
    const firstInsuredOptions = [];
    if (clientAccountType === AccountTypes.INDIVIDUAL || clientAccountType === AccountTypes.RPM) {
      const ownersInfo = getOwnerList(ownerList);
      if (ownersInfo && ownersInfo.length > 0) {
        firstInsuredOptions.push(...ownersInfo);
      }
    }
    if (clientAccountType === AccountTypes.JOINT) {
      const primaryOwner = getPrimaryOwner();
      const jointOwnerList = getJointOwnerList(jointOwner);
      firstInsuredOptions.push(
        { label: primaryOwner.label, value: primaryOwner.value }
      )
      if (jointOwnerList && jointOwnerList.length > 0) {
        firstInsuredOptions.push(...jointOwnerList);
      }
    }
    if (isAddOther) {
      firstInsuredOptions.push({ label: 'Other', value: 'Other' })
    }
    return firstInsuredOptions;
  }

  const getSecondInsuredOptions = () => {
    const arr = getFirstInsuredOptions(false).filter(item => item.value !== props.formState.insured);
    arr.push({ label: 'Other', value: 'Other' })
    return arr;
  }

  const getClientDetailFields = () => {
    return (
      <React.Fragment>
        <ExistingClientAccountFields
          showDropDown={showDropDown}
          formState={props.formState}
          register={register}
          errors={errors}
          officeList={officeList}
          faList={faList}
          msFetchClientAccount={msFetchClientAccount}
          handleValueChange={handleValueChange}
        />

        {errorMessage !== '' && <div className="errorMessage">{ReactHtmlParser(errorMessage)}</div>}
        {
          loading && errorMessage === '' ?
            <Row className="d-flex justify-content-center">
              <CircularProgress className="mt-5 mb-5" />
            </Row>
            :
            errorMessage === '' && validAccountDetails(props) && visible &&
            <div>
              {clientData.licenseCheckResponse && clientData.licenseCheckResponse.isTeam && advisorList.length > 1 && advisorList !== undefined &&
                <React.Fragment>
                  <Form.Group>
                    <SelectInput
                      name="advisor"
                      id="advisor"
                      value={props.formState.advisor}
                      onChange={(e) => handleValueChange('advisor', e.target.value)}
                      label="Who is the primary financial advisor?"
                      selectOptions={getAdvisorList(advisorList)}
                      errors={errors.advisor}
                      inputRef={register}
                    />
                  </Form.Group>
                </React.Fragment>
              }
              <AccountTypesAndOwnerFields
                formState={props.formState}
                register={register}
                errors={errors}
                handleValueChange={handleValueChange}
                clientData={clientData}
                ownerList={ownerList}
                jointOwner={jointOwner}
                getOwnerList={getOwnerList}
                getPrimaryOwner={getPrimaryOwner}
                getJointOwnerList={getJointOwnerList}
              />
              <PolicyAndInsuredFields
                formState={props.formState}
                register={register}
                errors={errors}
                isMSEnableSurvivorshipWorkflow={isMSEnableSurvivorshipWorkflow}
                disableSurvivorshipDropDown={props.disableSurvivorshipDropDown}
                clientData={clientData}
                jointOwner={jointOwner}
                handleValueChange={handleValueChange}
                getFirstInsuredOptions={getFirstInsuredOptions}
                getSecondInsuredOptions={getSecondInsuredOptions}
                getInsuredList={getInsuredList}
              />
              {props.isTermRetrieveQuote && retrieveSavedQuotes &&
                <Form.Group>
                  <StyledRadioInput
                    name="isSavedQuote"
                    id="isSavedQuote"
                    label="Would you like to retrieve a saved quote?"
                    value={props.formState.isSavedQuote}
                    options={yesNoOptions}
                    onChange={e => handleValueChange('isSavedQuote', e)}
                    errors={errors.isSavedQuote}
                    labelCenter={true}
                  />
                </Form.Group>
              }
              {props.isTermRetrieveQuote && props.formState.isSavedQuote === 'true' &&
                <Form.Group>
                  <SelectInput
                    name="selectQuote"
                    id="selectQuote"
                    value={parseInt(props.formState.selectQuote, 10)}
                    onChange={(e) => handleValueChange('selectQuote', e.target.value)}
                    label="Select a quote"
                    selectOptions={getQuoteList(quoteList)}
                    errors={errors.selectQuote}
                    inputRef={register}
                  />
                </Form.Group>
              }
            </div>
        }
      </React.Fragment>
    )
  }

  return (
    <Container fluid className='border-class'>
      <Form onSubmit={handleSubmit(handleOnSubmit)}>
        <Row className="justify-content-center pt-4 client-coverage">
          <Col lg={4}>
            <TitleComponent icon={SingleUserSearch} title="Advisor Setup" />
            {props.hideClientTypeRadio ? null :
              <React.Fragment>
                <Form.Group className='mb-1'>
                  <StyledRadioInput
                    name="clientType"
                    id="clientType"
                    value={props.formState.clientType}
                    options={clientTypeOptions}
                    onChange={(e) => handleValueChange('clientType', e)}
                    errors={errors.clientType}
                    labelCenter={true}
                  />
                </Form.Group>
                {props.formState.clientType === "Prospect" && !props.isTerm &&
                  <React.Fragment>
                    <Form.Group>
                      <TextInput
                        name="officeFa"
                        id="officeFa"
                        label="Office-FA #"
                        value={props.formState.officeFa}
                        errors={errors && errors.officeFa}
                        inputRef={register}
                        onBlur={() => msFetchClientAccount()}
                        onChange={(e) => handleValueChange('officeFa', e.target.value)}
                        InputProps={{
                          inputComponent: InputMaskOfficeFA
                        }}
                        onKeyPress={(e) => {
                          if (e.key === 'Enter') {
                            e.preventDefault();
                          }
                        }}
                      />
                    </Form.Group>
                    {errorMessage !== '' && <div className="errorMessage">{ReactHtmlParser(errorMessage)}</div>}
                    {loading && errorMessage === '' ?
                      <Row className="d-flex justify-content-center">
                        <CircularProgress className="mt-5 mb-5" />
                      </Row>
                      :
                      errorMessage === '' && validAccountDetails(props) && visible && clientData.licenseCheckResponse && clientData.licenseCheckResponse.isTeam && advisorList.length > 1 && advisorList !== undefined &&
                      <Form.Group>
                        <SelectInput
                          name="advisor"
                          id="advisor"
                          value={props.formState.advisor}
                          onChange={(e) => handleValueChange('advisor', e.target.value)}
                          label="Who is the primary financial advisor?"
                          selectOptions={getAdvisorList()}
                          errors={errors.advisor}
                          inputRef={register}
                        />
                      </Form.Group>
                    }
                  </React.Fragment>
                }
              </React.Fragment>
            }
            {
              !props.hideClientTypeRadio ? (props.formState.clientType === 'Existing' ? getClientDetailFields() : null) : getClientDetailFields()
            }
          </Col>
        </Row>
        <BackNextButton onBack={props.onBack} disabled={loading || errorMessage !== ''} />
      </Form>
    </Container>
  );
}

RetrieveAccount.ValidationSchema = (clientData, jointOwner, selectedOwnerRec, hideClientTypeRadio = false, isTerm, isTermRetrieveQuote = false, showDropDown = false, officeLength, isMSEnableSurvivorshipWorkflow = false) => {
  const isClientHaveSavedQuotes = clientData && clientData.savedQuotes && clientData.savedQuotes.length > 0;
  const clientAccountType = clientData && clientData.accountType && clientData.accountType.toLowerCase();
  const isIndividual = clientAccountType === AccountTypes.INDIVIDUAL;
  const isJoint = clientAccountType === AccountTypes.JOINT;
  const isTrust = clientAccountType === AccountTypes.TRUST;
  const isUnInCorporated = clientAccountType === AccountTypes.UNINCORPORATED;
  const isPartnership = clientAccountType === AccountTypes.PARTNERSHIP;
  const isLimitedLiability = clientAccountType === AccountTypes.LIMITED_LIABILITY;
  const isRPM = clientAccountType === AccountTypes.RPM;
  const isShowInsuredOptionsForAccountType = isIndividual || isRPM;
  const isShowPolicyTypeForAccountType = isTrust || isPartnership || isUnInCorporated || isLimitedLiability;

  return object().shape({
    clientType: hideClientTypeRadio ? string().notRequired() : string().required('Client Type is required.'),
    clientData: mixed().notRequired(),
    branchOptions: string().when('clientType', {
      is: (clientType) => clientType === 'Existing' && showDropDown && officeLength > 0,
      then: string().required('This field is required'),
      otherwise: string().notRequired(),
    }),
    faNum: string().when('branchOptions', {
      is: (branchOptions) => branchOptions === 'INPUT',
      then: customValidators.string().required('Office FA is required.').isValidOfficeFA('Invalid FA #. 3 digit FA # must be between 001 and 999.', 3, true, true),
      otherwise: string().notRequired(),
    }),
    officeNum: string().when('branchOptions', {
      is: (branchOptions) => branchOptions === 'INPUT',
      then: string().required('This field is required'),
      otherwise: string().notRequired(),
    }),
    officeFa: string().when(['clientType', 'branchOptions'], {
      is: (clientType, branchOptions) => (((clientType === 'Existing') || (clientType === 'Prospect' && !hideClientTypeRadio && !isTerm)) && (!showDropDown || (showDropDown && (branchOptions === 'SELECT' || officeLength === 0)))),
      then: customValidators.string().required('Office FA is required.').isValidOfficeFA('Invalid Office-FA #. 3 digit Office # must be between 001 and 999. 3 digit FA # must be between 001 and 999.', 7),
      otherwise: string().notRequired()
    }),
    officeAccount: string().when(['clientType', 'branchOptions'], {
      is: (clientType, branchOptions) => clientType === 'Existing' && (!showDropDown || (showDropDown && (branchOptions !== '' || officeLength === 0))),
      then: customValidators.string().required('Office FA Account is required.').isValidFAAccount('Invalid Office-Account #. 3 digit Office # must be between 001 and 999. 6 digit Account # must be between 000001 and 999999.', 9),
      otherwise: string().notRequired()
    }),
    advisor: string().when(['clientType', 'clientData'], {
      is: (clientType, clientData) => clientData.licenseCheckResponse && clientData.licenseCheckResponse.isTeam && clientData.licenseCheckResponse.quoteFAList.length > 1 && (clientType === 'Existing' || (clientType === 'Prospect' && !hideClientTypeRadio && !isTerm)),
      then: string().required('Advisor is required.'),
      otherwise: string().notRequired()
    }),
    isProposedInsured: string().when(['clientType', 'insurancePolicyType'], {
      is: (clientType, insurancePolicyType) => clientType === 'Existing' && clientData.accountType &&
        (
          (isMSEnableSurvivorshipWorkflow ? (insurancePolicyType === insurancePolicyTypes.INDIVIDUAL) : true) && (isJoint || isIndividual ||
            (clientData.accountType && isUnInCorporated && clientData.accountSubclass.toLowerCase() === AccountTypes.SOLE_PROPRIETOR && selectedOwnerRec && selectedOwnerRec.ownerType === null) ||
            (clientData.accountType && isUnInCorporated && (selectedOwnerRec && selectedOwnerRec.ownerType && selectedOwnerRec.ownerType.toLowerCase() !== OwnerType.ORGANIZATION)) ||
            (clientData.accountType && isPartnership && (selectedOwnerRec && selectedOwnerRec.ownerType && selectedOwnerRec.ownerType.toLowerCase() !== OwnerType.ORGANIZATION)))
        ),
      then: string().required('This field is required.'),
      otherwise: string().notRequired()
    }),
    policyOwnership: string().when('clientType', {
      is: (clientType) => clientType === 'Existing' && isJoint,
      then: string().required('This field is required.'),
      otherwise: string().notRequired()
    }),
    owner: string().when(['clientType', 'policyOwnership'], {
      is: (clientType, policyOwnership) => clientType === 'Existing' && (isIndividual ||
        (isJoint && policyOwnership === policyOwnerships.INDIVIDUAL) ||
        (isUnInCorporated && !clientData.accountSubclass.toLowerCase().includes(AccountTypes.UNINCORPORATED)) ||
        isPartnership
      ),
      then: string().required('This field is required.'),
      otherwise: string().notRequired()
    }),
    jointOwner: string().when(['clientType', 'policyOwnership'], {
      is: (clientType, policyOwnership) => clientType === 'Existing' && policyOwnership === policyOwnerships.JOINT && jointOwner.length >= 1,
      then: string().required('This field is required.'),
      otherwise: string().notRequired()
    }),
    insurancePolicyType: string().when(['clientType', 'policyOwnership'], {
      is: (clientType, policyOwnership) => isMSEnableSurvivorshipWorkflow && clientType === 'Existing' &&
        ((isJoint && policyOwnership !== '') || isShowInsuredOptionsForAccountType || isShowPolicyTypeForAccountType),
      then: string().required('This field is required.'),
      otherwise: string().notRequired()
    }),
    secondInsured: string().when(['clientType', 'insurancePolicyType'], {
      is: (clientType, insurancePolicyType) => clientType === 'Existing' &&
        (isJoint || isShowInsuredOptionsForAccountType) &&
        insurancePolicyType === insurancePolicyTypes.SURVIVORSHIP,
      then: string().required('This field is required.'),
      otherwise: string().notRequired()
    }),
    insured: string().when(['clientType', 'policyOwnership', 'isProposedInsured', 'insurancePolicyType'], {
      is: (clientType, policyOwnership, isProposedInsured, insurancePolicyType) => clientType === 'Existing' &&
        ((policyOwnership === policyOwnerships.JOINT && jointOwner !== '' && isProposedInsured === "true" && jointOwner.length >= 1) ||
          ((isJoint || isShowInsuredOptionsForAccountType)
            && isMSEnableSurvivorshipWorkflow === true && insurancePolicyType === insurancePolicyTypes.SURVIVORSHIP)),
      then: string().required('This field is required.'),
      otherwise: string().notRequired()
    }),
    isSavedQuote: string().when('clientType', {
      is: (clientType) => clientType === 'Existing' && isTermRetrieveQuote === true && isClientHaveSavedQuotes,
      then: string().required('This field is required.'),
      otherwise: string().notRequired()
    }),
    selectQuote: string().when(['clientType', 'isSavedQuote'], {
      is: (clientType, isSavedQuote) => clientType === 'Existing' && isSavedQuote === 'true' && isTermRetrieveQuote === true && isClientHaveSavedQuotes,
      then: string().required('This field is required.'),
      otherwise: string().notRequired()
    }),
  });
}

RetrieveAccount.DefaultFormState = (prefill = false, isMSEnableSurvivorshipWorkflow = false) => {

  const insurancePolicyTypeDefault = isMSEnableSurvivorshipWorkflow ? '' : 'Individual';
  return {
    clientType: prefill ? 'Existing' : 'Existing',
    officeFa: prefill ? '101-472' : '',
    officeAccount: prefill ? '101-147145' : '',
    isProposedInsured: prefill ? 'true' : '',
    owner: '',
    policyOwnership: prefill ? 'joint' : '',
    jointOwner: '',
    insured: '',
    isSavedQuote: prefill ? 'true' : '',
    selectQuote: prefill ? '' : '',
    clientData: {},
    ownerDetails: {},
    advisor: '',
    branchOptions: '',
    officeNum: '',
    accountNum: '',
    insurancePolicyType: insurancePolicyTypeDefault,
    secondInsured: '',
  };
};

RetrieveAccount.propTypes = {
  formState: PropTypes.object.isRequired,
  fullFormState: PropTypes.object.isRequired,
  onNext: PropTypes.func.isRequired,
  onBack: PropTypes.func.isRequired,
  onFieldChange: PropTypes.func.isRequired
};



// WEBPACK FOOTER //
// ./src/components/Product/SharedComponents/RetrieveAccount/RetrieveAccount.js